import React from 'react';
import PropTypes from 'prop-types';
import { FilterFilled, SearchOutlined } from '@ant-design/icons';
import { Table, Popover, Rate, Input, InputNumber, DatePicker } from 'antd';
import { communicationStatus, platformEntity, entityAction } from '~constants';
import { connect } from 'react-redux';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import * as actions from '~actions/reviews';
import SearchProperty from '~pages/dashboard/reviews/table/search-property';
import Images from '~pages/dashboard/reviews/image';
import ContentText from '~pages/dashboard/reviews/table/content-text';
import showElementByAuth from '~helpers/auth';
import { dayFormatType, formatDay, moment } from '~helpers/day';

const mapStateToProps = state => ({
  communication: state.dashboard.reviews.get('communication')?.toJS(),
});

const mapDispatchToProps = dispatch => ({
  deletedReview: (id, successCallback) => {
    dispatch(actions.deleteReview(id, successCallback));
  },

  rejectReview: (id, successCallback, isUnpublish) => {
    dispatch(actions.rejectReview(id, successCallback, isUnpublish));
  },

  approvalReview: (id, successCallback) => {
    dispatch(actions.approvalReview(id, successCallback));
  },
});

@connect(mapStateToProps, mapDispatchToProps)
export default class ReviewsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      ratingMin: null,
      ratingMax: null,
      propertySlugs: '',
      updatedAtMax: '',
      updatedAtMin: '',
      createdAtMax: '',
      createdAtMin: '',
      nickNameLike: '',
      showScoreFilter: false,
      showReviewDetailsFilter: false,
      showPropertyFilter: false,
      showCreatedTimeFilter: false,
      showUpdatedTimeFilter: false,
      showStudentNameFilter: false,
    };

    this.ratingType = [
      'ratingLocation',
      'ratingTransport',
      'ratingSafety',
      'ratingStaff',
      'ratingValue',
    ];
  }

  componentDidUpdate(prevProps) {
    const currentStatus = this.props.filters.statuses && this.props.filters.statuses[0];
    const prevStatus = prevProps.filters.statuses && prevProps.filters.statuses[0];
    if (currentStatus !== prevStatus) {
      this.setState({
        content: '',
        ratingMin: null,
        ratingMax: null,
        propertySlugs: '',
        updatedAtMax: '',
        updatedAtMin: '',
        createdAtMax: '',
        createdAtMin: '',
        nickNameLike: '',
      });
    }
  }

  formatRating = value => {
    if (typeof value === 'number') {
      const fullStarsCount = Math.floor(value);
      const decimal = value - fullStarsCount;

      if (decimal > 0 && decimal < 0.4) {
        return fullStarsCount + 0.5;
      }

      if (decimal >= 0.5) {
        return fullStarsCount + 1;
      }
    }
    return value;
  };

  renderRating = record => (
    <For each="type" index="index" of={this.ratingType}>
      <If condition={record[type] > 0}>
        <div className="reviews-tab__rating-type" key={type}>
          <span className="reviews-tab__rating-title">
            {this.props.t(
              `cms.reviews.table.${type.toLowerCase().replace('rating', 'rating_')}.type`,
            )}
          </span>
          <Rate disabled allowHalf defaultValue={this.formatRating(record[type])} />
        </div>
      </If>
    </For>
  );

  handleContent = ({ target: { value } }) => {
    this.setState({
      content: value,
    });
  };

  handleStudentNameInput = ({ target: { value } }) => {
    this.setState({
      nickNameLike: value,
    });
  };

  setfilter = (e, type) => {
    if (!e && type) {
      this.props.onSearch(this.state[type], type);
    }
  };

  inputChange = (e, type) => {
    if (['ratingMax', 'ratingMin'].indexOf(type) !== -1) {
      this.state[type] = typeof e === 'number' ? Number(e) : 0;
    }
    if (type === 'content') {
      this.state.content = e.target ? e.target.value : '';
    }
    if (type === 'propertySlugs') {
      this.state.propertySlugs = e ? [e] : null;
    }

    this.setState(this.state);
  };

  filterRating = e => {
    if (!e) {
      this.props.searchScore(this.state.ratingMin, this.state.ratingMax);
    }
    this.setState({ showScoreFilter: e });
  };

  updatedDateChange = e => {
    let min = '';
    let max = '';
    if (e && e.length > 0) {
      min = formatDay(dayFormatType.APIPARAMS, moment(e[0]).startOf('day'));
      max = formatDay(dayFormatType.APIPARAMS, moment(e[1]).endOf('day'));
    }

    this.setState({
      updatedAtMax: max,
      updatedAtMin: min,
    });
  };

  createdDateChange = e => {
    let min = '';
    let max = '';
    if (e && e.length > 0) {
      min = formatDay(dayFormatType.FILTERPARAMS, e[0]);
      max = formatDay(dayFormatType.FILTERPARAMS, e[1]);
    }

    this.setState({
      createdAtMax: max,
      createdAtMin: min,
    });
  };

  filterUpdatedDate = e => {
    if (!e) {
      this.props.searchUpdatedDate(this.state.updatedAtMin, this.state.updatedAtMax);
    }
    this.setState({ showUpdatedTimeFilter: e });
  };

  filterCreatedDate = e => {
    if (!e) {
      this.props.searchCreatedDate(this.state.createdAtMin, this.state.createdAtMax);
    }
    this.setState({ showCreatedTimeFilter: e });
  };

  isHaveReviewsUpdateAuth = () =>
    showElementByAuth(platformEntity.REVIEWS_REVIEWS, entityAction.UPDATE);

  tableColumns = () => [
    {
      title: this.props.t('cms.reviews.table.score'),
      dataIndex: 'rating',
      key: 'rating',
      width: '8%',
      className: 'reviews-tab__score',
      filterIcon: (
        <FilterFilled
          style={{
            color:
              this.props.filters.ratingMax || this.props.filters.ratingMin ? '#38b2a6' : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      filterDropdown: (
        <>
          {this.state.showScoreFilter ? (
            <div className="reviews-tab__filter">
              <span className="reviews-tab__filter-title">
                {this.props.t('cms.reviews.table.rating_filter.title')}
              </span>
              <Input.Group compact>
                <InputNumber
                  value={this.state.ratingMin}
                  max={
                    this.state.ratingMax > 0 && this.state.ratingMax < 5 ? this.state.ratingMax : 5
                  }
                  min={0}
                  onChange={e => {
                    this.inputChange(e, 'ratingMin');
                  }}
                  style={{ width: 108, textAlign: 'center' }}
                  placeholder={this.props.t('cms.reviews.table.rating_filter.placeholder.min')}
                />
                <Input
                  style={{
                    width: 30,
                    borderLeft: 0,
                    borderRight: 0,
                    pointerEvents: 'none',
                    backgroundColor: '#fff',
                    marginLeft: 1,
                    marginRight: 1,
                  }}
                  placeholder="~"
                  disabled
                />
                <InputNumber
                  value={this.state.ratingMax}
                  max={5}
                  min={this.state.ratingMin ? this.state.ratingMin : 0}
                  onChange={e => {
                    this.inputChange(e, 'ratingMax');
                  }}
                  style={{ width: 108, textAlign: 'center' }}
                  placeholder={this.props.t('cms.reviews.table.rating_filter.placeholder.max')}
                />
              </Input.Group>
            </div>
          ) : null}
        </>
      ),
      filterDropdownVisible: this.state.showScoreFilter,
      onFilterDropdownVisibleChange: this.filterRating,
      render: (text, record) => (
        <div>
          <Choose>
            <When condition={this.ratingType.filter(item => record[item] > 0).length === 0}>
              <span className="reviews-tab__rating">{text.toFixed(1)}</span>
            </When>
            <Otherwise>
              <Popover key={record.id} placement="topLeft" content={this.renderRating(record)}>
                <span className="reviews-tab__rating--hover">{text.toFixed(1)}</span>
              </Popover>
            </Otherwise>
          </Choose>
        </div>
      ),
    },
    {
      title: this.props.t('cms.reviews.table.review_details'),
      dataIndex: 'content',
      key: 'content',
      width: '35%',
      className: 'reviews-tab__text',
      filterIcon: (
        <SearchOutlined
          style={{
            color: this.props.filters.content ? '#38b2a6' : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      onFilterDropdownVisibleChange: e => {
        this.setfilter(e, 'content');
        this.setState({ showReviewDetailsFilter: e });
      },
      filterDropdownVisible: this.state.showReviewDetailsFilter,
      filterDropdown: (
        <>
          {this.state.showReviewDetailsFilter ? (
            <div className="reviews-tab__filter reviews-tab__filter-content">
              <Input
                allowClear
                style={{ width: 214 }}
                defaultValue={this.props.filters.content}
                onChange={this.handleContent}
                placeholder={this.props.t('cms.reviews.table.details.placeholder')}
              />
            </div>
          ) : null}
        </>
      ),
      render: (text, record) => (
        <span key={text}>
          <ContentText record={record} t={this.props.t} />
          <If
            condition={
              (record.propertyImages && record.propertyImages.length > 0) ||
              (record.unitTypeImages && record.unitTypeImages.length > 0)
            }
          >
            <Images
              id={record.id}
              t={this.props.t}
              propertyImages={record.propertyImages}
              unitTypeImages={record.unitTypeImages}
              filters={this.props.filters}
            />
          </If>
        </span>
      ),
    },
    {
      title: this.props.t('cms.reviews.table.created_date'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '14%',
      filterIcon: (
        <FilterFilled
          style={{
            color:
              this.props.filters.createdAtMin || this.props.filters.createdAtMax
                ? '#38b2a6'
                : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      onFilterDropdownVisibleChange: this.filterCreatedDate,
      filterDropdownVisible: this.state.showCreatedTimeFilter,
      filterDropdown: (
        <>
          {this.state.showCreatedTimeFilter ? (
            <div className="reviews-tab__filter">
              <DatePicker.RangePicker
                allowClear
                format={dayFormatType.UKFORMAT}
                onChange={this.createdDateChange}
                defaultValue={
                  this.props.filters.createdAtMin
                    ? [
                        moment(this.props.filters.createdAtMin),
                        moment(this.props.filters.createdAtMax),
                      ]
                    : null
                }
              />
            </div>
          ) : null}
        </>
      ),
      render: (text, record) => (
        <span className="reviews-tab__text reviews-tab__date">
          <Choose>
            <When condition={this.props.filters.statuses === 'NEW'}>
              {formatDay(dayFormatType.UKWITHHM, record.createdAt)}
            </When>
            <Otherwise>{formatDay(dayFormatType.UKWITHHM, text)}</Otherwise>
          </Choose>
        </span>
      ),
    },
    {
      title: this.props.t('cms.reviews.table.updated_date'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: '14%',
      filterIcon: (
        <FilterFilled
          style={{
            color:
              this.props.filters.updatedAtMin || this.props.filters.updatedAtMax
                ? '#38b2a6'
                : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      onFilterDropdownVisibleChange: this.filterUpdatedDate,
      filterDropdownVisible: this.state.showUpdatedTimeFilter,
      filterDropdown: (
        <>
          {this.state.showUpdatedTimeFilter ? (
            <div className="reviews-tab__filter">
              <DatePicker.RangePicker
                allowClear
                format={dayFormatType.UKFORMAT}
                onChange={this.updatedDateChange}
                defaultValue={
                  this.props.filters.updatedAtMin
                    ? [
                        moment(this.props.filters.updatedAtMin),
                        moment(this.props.filters.updatedAtMax),
                      ]
                    : null
                }
              />
            </div>
          ) : null}
        </>
      ),
      render: (text, record) => (
        <span className="reviews-tab__text reviews-tab__date">
          <Choose>
            <When condition={this.props.filters.statuses === 'NEW'}>
              {formatDay(dayFormatType.UKWITHHM, record.createdAt)}
            </When>
            <Otherwise>{formatDay(dayFormatType.UKWITHHM, text)}</Otherwise>
          </Choose>
        </span>
      ),
    },
    {
      title: this.props.t('cms.reviews.table.property'),
      dataIndex: 'property',
      key: 'property',
      width: '18%',
      filterIcon: (
        <SearchOutlined
          style={{
            color:
              this.props.filters.propertySlugs && this.props.filters.propertySlugs.length > 0
                ? '#38b2a6'
                : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      filterDropdown: (
        <>
          {this.state.showPropertyFilter ? (
            <div className="reviews-tab__filter">
              <SearchProperty inputChange={this.inputChange} t={this.props.t} />
            </div>
          ) : null}
        </>
      ),
      filterDropdownVisible: this.state.showPropertyFilter,
      onFilterDropdownVisibleChange: e => {
        this.setfilter(e, 'propertySlugs');
        this.setState({ showPropertyFilter: e });
      },
      render: text => (
        <div>
          <HTMLEllipsis
            unsafeHTML={text && text.name ? text.name : '-'}
            maxLine="3"
            className="reviews-tab__text reviews-tab__property"
            ellipsisHTML={'...'}
          />
        </div>
      ),
    },
    {
      title: this.props.t('cms.reviews.table.unHiddenNickname'),
      dataIndex: 'unHiddenNickname',
      key: 'unHiddenNickname',
      width: '14%',
      filterIcon: (
        <SearchOutlined
          style={{
            color:
              this.props.filters.nickNameLike && this.props.filters.nickNameLike.length > 0
                ? '#38b2a6'
                : '#c8c9cb',
            backgroundColor: 'transparent',
          }}
        />
      ),
      filterDropdown: (
        <>
          {this.state.showStudentNameFilter ? (
            <div className="reviews-tab__filter reviews-tab__filter-content">
              <Input
                allowClear
                style={{ width: 214 }}
                defaultValue={this.props.filters.nickNameLike}
                onChange={this.handleStudentNameInput}
                placeholder={this.props.t('cms.reviews.table.details.placeholder')}
              />
            </div>
          ) : null}
        </>
      ),
      filterDropdownVisible: this.state.showStudentNameFilter,
      onFilterDropdownVisibleChange: e => {
        this.setfilter(e, 'nickNameLike');
        this.setState({ showStudentNameFilter: e });
      },
      render: text => (
        <div>
          <HTMLEllipsis
            unsafeHTML={text ? text : '-'}
            maxLine="3"
            className="reviews-tab__text reviews-tab__property"
            ellipsisHTML={'...'}
          />
        </div>
      ),
    },
  ];

  logSectionsColumn = () => ({
    title: this.props.t('cms.reviews.table.log_section'),
    dataIndex: 'id',
    key: 'id',
    width: '12%',
    className: 'reviews-tab__btn-td',
    render: id => {
      const { t, filters, communication } = this.props;
      return (
        <React.Fragment>
          <If
            condition={
              ['NEW', 'REJECTED'].indexOf(filters.statuses[0]) !== -1 &&
              this.isHaveReviewsUpdateAuth()
            }
          >
            <button
              className="reviews-tab__btn"
              onClick={
                communication.approval &&
                communication.approval.status === communicationStatus.FETCHING
                  ? () => {}
                  : () => {
                      this.handelApprovalReview(id);
                    }
              }
            >
              {t('cms.reviews.table.log_section.approve.btn')}
            </button>
          </If>
          <If condition={filters.statuses[0] === 'NEW' && this.isHaveReviewsUpdateAuth()}>
            <button
              className="reviews-tab__btn"
              onClick={
                communication.reject && communication.reject.status === communicationStatus.FETCHING
                  ? () => {}
                  : () => {
                      this.handelRejectReview(id);
                    }
              }
            >
              {t('cms.reviews.table.log_section.reject.btn')}
            </button>
          </If>
          <If
            condition={
              (filters.statuses[0] === 'APPROVED' || filters.statuses.length === 0) &&
              this.isHaveReviewsUpdateAuth()
            }
          >
            <button
              className="reviews-tab__btn"
              onClick={
                communication.reject && communication.reject.status === communicationStatus.FETCHING
                  ? () => {}
                  : () => {
                      this.handleUnpublishReview(id);
                    }
              }
            >
              {t('cms.reviews.table.log_section.unpublish.btn')}
            </button>
          </If>
        </React.Fragment>
      );
    },
  });

  handelDeletedReview = id => {
    this.props.deletedReview(id, () => {
      this.props.getReviews(this.props.filters);
    });
  };

  handelRejectReview = id => {
    this.props.rejectReview(id, () => {
      this.props.getReviews(this.props.filters);
    });
  };

  handleUnpublishReview = id => {
    this.props.rejectReview(
      id,
      () => {
        this.props.getReviews(this.props.filters);
      },
      true,
    );
  };

  handelApprovalReview = id => {
    this.props.approvalReview(id, () => {
      this.props.getReviews(this.props.filters);
    });
  };

  render() {
    const { list, communication, filters } = this.props;
    const tableColumns = this.tableColumns();
    if (this.isHaveReviewsUpdateAuth()) {
      tableColumns.push(this.logSectionsColumn());
    }

    return (
      <div className="reviews-tab">
        <Table
          rowKey="id"
          className="table-list"
          scroll={{ x: true }}
          columns={tableColumns}
          onChange={this.props.handleTableChange}
          dataSource={list.payload}
          loading={communication.list && communication.list.status === communicationStatus.FETCHING}
          pagination={{
            current: filters.pageNumber,
            pageSize: filters.pageSize,
            showSizeChanger: true,
            hideOnSinglePage: false,
            total: list.total,
            showQuickJumper: true,
          }}
        />
      </div>
    );
  }
}

ReviewsTable.propTypes = {
  t: PropTypes.func.isRequired,
  deletedReview: PropTypes.func,
  rejectReview: PropTypes.func,
  approvalReview: PropTypes.func,
  getReviews: PropTypes.func,
  handleTableChange: PropTypes.func,
  onSearch: PropTypes.func,
  searchScore: PropTypes.func,
  searchUpdatedDate: PropTypes.func,
  searchCreatedDate: PropTypes.func,
  communication: PropTypes.object,
  list: PropTypes.object,
  filters: PropTypes.object,
};

ReviewsTable.defaultProps = {
  t: () => {},
  rejectReview: () => {},
  deletedReview: () => {},
  approvalReview: () => {},
  getReviews: () => {},
  handleTableChange: () => {},
  onSearch: () => {},
  searchScore: () => {},
  searchUpdatedDate: () => {},
  searchCreatedDate: () => {},
  communication: {},
  list: {},
  filters: {},
};
